import { ChevronDown } from 'lucide-react';
import { type HTMLAttributes, useState } from 'react';

import Accordion from '@/components/Accordion/Accordion';
import { Flex } from '@/components/base';
import IconButton from '@/components/Button/IconButton';
import type { TypoProps } from '@/components/Typography';
import Typo from '@/components/Typography/Typo';
import { cn } from '@/lib/cn';

type PaneProps = HTMLAttributes<HTMLDivElement> & {
  title?: React.ReactNode;
  titleAction?: React.ReactNode;
  initialOpen?: boolean;
};

export const Pane = (props: PaneProps) => {
  const {
    title,
    titleAction,
    children,
    initialOpen = true,
    className,
    ...rest
  } = props;
  const [collapsed, setCollapsed] = useState(!initialOpen);
  return (
    <div
      className={cn('flex flex-col bg-gray-200 rounded-md gap-4', className)}
      {...rest}
    >
      <Accordion
        status={!collapsed}
        anchor={(isOpened) => (
          <Flex j="space-between" a="center" className="p-4 pb-0">
            <Flex a="center" className="cursor-pointer">
              <IconButton
                className="-ml-1"
                icon={
                  <ChevronDown
                    className={cn(
                      'transition-transform duration-200 size-3 text-gray-700',
                      isOpened ? '-rotate-180' : '',
                    )}
                  />
                }
                sizeType="s"
                outlined={false}
                onClick={() => {
                  setCollapsed(!collapsed);
                }}
              />
              <PaneTitle>{title}</PaneTitle>
            </Flex>
            {titleAction}
          </Flex>
        )}
        content={<div className="p-4 pt-0">{children}</div>}
      />
    </div>
  );
};

export const PaneTitle = (props: TypoProps) => {
  const { children, ...rest } = props;
  return (
    <Typo type="label2" className="select-none text-gray-700" {...rest}>
      {children}
    </Typo>
  );
};
